<template>
  <div :class="{ mobileOfRoutingStatus: !isExtraLargeScreen }">
    <Spinner v-if="isLoadingData || loadingData" :fullscreen="true">
      <template v-slot:header>Fetching data</template>
      We are fetching routing status data.
      <br />According to the size of the network this may take a while.</Spinner
    >

    <NormalHeaderLayout
      header="Routing status"
      :isWithoutBackground="true"
      :isAccessibleForAPNICStaff="true"
    >
      <template v-if="isUserWithoutMemberAccount">
        <NoAccountLinked></NoAccountLinked>
      </template>
      <template v-else-if="isSuccessfulSummaryRequest">
        <Header></Header>
        <Overview></Overview>
        <RoutingStatusSection></RoutingStatusSection>
      </template>
    </NormalHeaderLayout>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Spinner from '../components/ui/Spinner.vue';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';
import Header from '../components/routingStatus/Header.vue';
import Overview from '../components/routingStatus/Overview.vue';
import RoutingStatusSection from '../components/routingStatus/RoutingStatusSection.vue';
import NoAccountLinked from '../components/ui/NoAccountLinked.vue';

export default {
  name: 'RoutingStatus',
  components: {
    Spinner,
    NormalHeaderLayout,
    Header,
    Overview,
    RoutingStatusSection,
    NoAccountLinked
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['isSuccessfulSummaryRequest']),
    ...mapState('dataStore', ['selectedASN', 'loadingData']),
    ...mapState('routingStatusStore', ['isLoadingData']),
    ...mapGetters(['isExtraLargeScreen']),
    ...mapGetters('dataStore', ['noAccount']),

    isUserWithoutMemberAccount() {
      return this.isSuccessfulSummaryRequest && this.noAccount;
    }
  },
  methods: {
    ...mapActions('dataStore', ['selectASN']),
    ...mapActions('routingStatusStore', ['fetchRoutingStatusDataOfPrefixes'])
  },
  mounted() {
    const asnId = this.selectedASN && this.selectedASN.id;

    if (asnId) {
      this.selectASN(asnId);
    } else {
      this.fetchRoutingStatusDataOfPrefixes();
    }
  }
};
</script>

<style lang="scss" scoped>
.mobileOfRoutingStatus {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
